/**
 * 使用常量替代 Mutation 事件类型，对整个app包含的mutation一目了然。
 * 
 * 命名：大写字母加注释。
 */

// export const SET_GLOBAL_INFO = "SET_GLOBAL_INFO"                        // 设置global信息（用户信息、店铺列表、店铺config信息、权限列表、打印机信息、货品单位信息

export const SET_SHOP_INFO = "SET_SHOP_INFO"  // 设置当前的店铺信息
export const SET_FORM_IMG = "SET_FORM_IMG" // 设置上传的照片信息
export const CLEAR_FORM_IMG = "CLEAR_FORM_IMG" // 清空上传的照片信息
